import { useEffect, useRef, useState } from 'react';

export const Counter = ({ vars, correct }) => {
  const [count, setCount] = useState(null);
  const indexCount = useRef(0);

  useEffect(() => {
    if (count === correct || indexCount.current > vars?.length - 1) {
      return;
    }

    const idInterval = setInterval(() => {
      setCount(vars[indexCount.current]);

      indexCount.current++;
    }, 200);

    return () => {
      clearInterval(idInterval);
    };
  }, [count, vars]);

  return <span>{count}</span>;
};
